import React from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import { blogDataList } from '../../Data/More_Data/blogData';

export default function Recent_Posts() {
  const location = useLocation();
  const currentUrl = location.pathname;
  const filteredPosts = blogDataList.filter((post) => post.blogLink !== currentUrl).slice(0, 5);


  return (
    <>
      {blogDataList && (
        <div className="widget widget_recent_entries">
          <h3 className="widget_title">Recent Posts</h3>
          <div className="recent-posts">
            {filteredPosts.map((post, index) => (

              <div key={index} className="recent-post" style={{flexDirection:"column"}}>
                <div className="media-img" style={{width:"100%"}}>
                  <a
                    href=""
                    onClick={(event) => event.preventDefault()}
                  >
                    <img
                      src={post.imageSrc}
                      loading="lazy"
                      alt={post.title}
                    />
                  </a>
                </div>
                <div className="recent-post-body">
                  <h4 className="post-title">
                    <NavLink
                      className="text-inherit"
                      to={`${post.blogLink}`}
                    >
                      {post.title}
                    </NavLink>
                  </h4>
                  <div className="recent-post-meta">
                    <a
                      href=""
                      onClick={(event) => event.preventDefault()}
                    >
                      <i className="fal fa-calendar-days"></i>
                      {post.date}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

    </>
  )
}
